import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import VideoBox from "components/VideoBox"

interface VideoLargeProps {
  title: string
  subhead?: string
  id?: string
  src: string
  poster: string
  isTitleSizeLarge?: boolean
  preload?: string
}

const VideoLarge: React.FC<VideoLargeProps> = ({
  title,
  subhead,
  id,
  src,
  poster,
  preload,
  isTitleSizeLarge,
}) => {
  return (
    <section className={styles.videoLarge}>
      <div className={styles.pagePadding}>
        <div className={styles.message}>
          <h3
            className={cx({
              [styles.heading]: true,
              [styles.lg]: isTitleSizeLarge,
              [styles.md]: !isTitleSizeLarge,
            })}
          >
            {title}
          </h3>
          {subhead && <p className={styles.subhead}>{subhead}</p>}
        </div>
        <div className={styles.video}>
          <VideoBox
            id={id}
            src={src}
            poster={poster}
            preload={preload || "metadata"}
          />
        </div>
      </div>
    </section>
  )
}

export default VideoLarge
